import React, { useMemo, memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { DataGridColumnHeader } from './dataGridColumnHeader';

export const DataGridHeader = memo(
  ({ children, sortBy, sortByDirection, onSort }) => {
    const { styles } = useStyle();

    const columns = useMemo(
      () =>
        React.Children.map(children, (element) => {
          const {
            title,
            sortable,
            sortKey,
            flex = 1,
            fieldName,
          } = element.props;
          return { title, sortable, sortKey, flex, fieldName };
        }),
      [children]
    );

    return (
      <View style={styles.headerContainer}>
        {columns.map((item) => (
          <DataGridColumnHeader
            {...item}
            {...{ sortBy, sortByDirection, onSort }}
          />
        ))}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    height: 56,
  },
}));
